import { Client } from 'typesense';
import {
  ConfigurationOptions,
  NodeConfiguration,
} from 'typesense/lib/Typesense/Configuration';

export const TYPESENSE_NODE: NodeConfiguration = {
  host: process.env.NEXT_PUBLIC_IS_STAGING
    ? 'typesense.mxlocker.dev'
    : 'typesense-lb.mxlocker.com',
  port: 443,
  protocol: 'https',
};

const getConfig = (
  cache: 'short' | 'medium' | 'long' = 'short'
): ConfigurationOptions => {
  return {
    apiKey: process.env.NEXT_PUBLIC_TYPESENSE_SEARCH_KEY!,
    nodes: [{ ...TYPESENSE_NODE, path: cache === 'short' ? '' : `/${cache}` }],
    connectionTimeoutSeconds: 10000,
    useServerSideSearchCache: true,
  };
};

let shortClient: Client | null = null; // cached for 1 minute
let mediumClient: Client | null = null; // cached for 10 minutes on browser, 2 days on CDN
let longClient: Client | null = null; // cached for 1 day on browser, 1 year on CDN
export const getTypesenseClient = <T extends Record<string, any>>(
  collection: // products_alias is not allowed here. use getTypesenseClientServer instead
  | 'product_queries'
    | 'vehicles_alias'
    | 'sellers'
    | 'categories_alias'
    | 'faqs',
  cache: 'short' | 'medium' | 'long' = 'short'
) => {
  if (cache === 'long') {
    if (!longClient) longClient = new Client(getConfig('long'));
    return longClient.collections<T>(collection);
  }
  if (cache === 'medium') {
    if (!mediumClient) mediumClient = new Client(getConfig('medium'));
    return mediumClient.collections<T>(collection);
  }
  if (!shortClient) shortClient = new Client(getConfig());
  return shortClient.collections<T>(collection);
};
